export enum InboxRedesignDataEventObjectsEnum {
  INBOX_REDESIGN_TOGGLED = 'inbox_redesign_toggled',
  INBOX_REDESIGN_GA_TOGGLED = 'inbox_redesign_ga_toggled',
  INBOX_IMPROVEMENTS_TOGGLED = 'inbox_improvements_toggled',
  INBOX_IMPROVEMENTS_LAUNCH_EDUCATION_TIP = 'inbox_improvements_launch_education_tip',
}
